




















import { defineComponent } from '@vue/composition-api'
import { Document } from '@contentful/rich-text-types'
import AnslPageBannerCf from '@/components/PageBannerCf.vue'
import { AnslGenericPageAlerts } from '@/components/common'

export default defineComponent({
  components: {
    AnslPageBannerCf,
    AnslGenericPageAlerts
  },
  props: {
    loading: Boolean,
    exception: Boolean,
    light: {
      type: Boolean,
      default: true
    },
    showAddress: {
      type: Boolean,
      default: false
    },
    bannerTitle: {
      type: String,
      default: ''
    },
    bannerDescription: {
      type: Document,
      default: undefined
    },
    bannerParagraph: {
      type: Document,
      default: undefined
    },
    bannerBackground: {
      type: String,
      default: ''
    }
  }
})
